
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './initpage.scss';








const Pinitpage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id6930740e8e5aed52dc8a7dc6" >

      <div id="iaxm" className="">
      
      <div id="ilbz" className="">
      
      <div id="i8dkwz" className="">
      
      <div id="it8o" className="">
      
      <img
        className=""
        id="iab3w"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqbbqw7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i7t6i" className="">
      
        <a
          target=""
          className=""
          id="i2vec"
          href="#ilbz"
        >
          
    <div id="i7wdz" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="igwwv"
          href="#i3mem9"
        >
          
    <div id="ihduh" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i8k0h"
          href="#inhmqm"
        >
          
    <div id="iw13j" className="">
    <>Servicios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i6n6c"
          href="#i716zi"
        >
          
    <div id="ir26r" className="">
    <>Porque Elegirnos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i64tg"
          href="#"
        >
          
    <div id="in28q" className="">
    <>Portafolio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i1f01"
          href="#i49wha"
        >
          
    <div id="iokdf" className="">
    <>Contacto</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ipcx8" className="">
      
      <div
        id="iswg5h"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iiojl" className="">
      
      <div id="izhqy" className="">
      
      <div className="" id="it09m">
        
      <span className="" id="i186tr">
        <>Impulsa tu marca</>
      </span>
      
      </div>
      
      <img
        className=""
        id="i49b2"
        src="https://assetsprojects.s3.amazonaws.com/404pziiml77i0p5.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iww5g">
        <>Conecta con tu público</>
      </div>
      
        <a
          target=""
          className=""
          id="iekvm4"
          href="#"
        >
          
      <div className="" id="ina0uc">
        
      <span className="" id="ih4u0g">
        
      <a
        target=""
        className=""
        id="ib7zmr"
        href="https://wa.me/50488006991"
        type=""
      >
        <>Hablemos</>
      </a>
      
      </span>
      
      </div>
      
      <div id="ioxb24" className="">
      
      <span className="material-icons " id="iuxn3z">
        
      <span className="material-icons " id="iwed6g">
        <>play_arrow</>
      </span>
      
      </span>
      <>
        </>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="imp0i" className="">
      
      <div id="iwyufa" className="">
      
      <img
        className=""
        id="ickhl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqjkp1s.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="igcxb" className="">
      
      <div className="" id="ij3dl">
        <>Creamos </>
      <span className="" id="i6m0z">
        <>experiencias visuales</>
      </span>
      <> y digitales que hacen </>
      <span className="" id="is60d">
        <>crecer tu negocio</>
      </span>
      <>.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="is7h" className="">
      
      <img
        className=""
        id="izv0w"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqfk8am.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iaa6bm" className="">
      
      <div
        id="i9ui1v"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i3mem9" className="">
      
      <div id="i29sja" className="">
      
      <div id="ii24su" className="">
      
      <div className="" id="injwmi">
        
      <span className="" id="i61nxy">
        <>Quienes Somos</>
      </span>
      
      </div>
      
      <img
        className=""
        id="iqdy0m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiz4ffq3.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ibefl" className="">
      <>
        </>
      </div>
      
      <div className="" id="immri">
        <>Somos una agencia de marketing integral especializada en construir marcas memorables.</>
      </div>
      
      <img
        className=""
        id="i1x5hn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqjuuqx.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i334pv" className="">
      
      <div id="ilra68" className="">
      <>
        </>
      </div>
      
      <div id="izoluj" className="">
      
      <div className="" id="ip41ds">
        <>Nuestro equipo combina la visión artística con el análisis de resultados para que cada proyecto no solo se vea bien, sino que funcione.</>
      </div>
      <>
        </>
      </div>
      
      <img
        className=""
        id="i14hvk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqjw25d.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="inhmqm" className="">
      
      <div id="imtabb" className="">
      
      <div id="imkun" className="">
      
      <div className="" id="i00mj">
        
      <span className="" id="icvc08">
        <>Servicios</>
      </span>
      
      </div>
      
      <img
        className=""
        id="iroxk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiz4ffq3.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ixi5j" className="">
      <>
        </>
      </div>
      
      <div className="" id="im82mi">
        <>Creamos soluciones diseñadas para aquellos que saben que el presente y el futuro de su negocio están en un diseño limpio, fuerte y adecuado para sus clientes.</>
      </div>
      
      <img
        className=""
        id="i76nrc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirl0z2z.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i6qid4" className="">
      
      <div id="imnrro" className="">
      <>
        </>
      </div>
      
      <div
        id="isvk9f"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="imrjpa" className="">
      
      <div id="iz45ml" className="">
      
      <div id="i2vobf" className="">
      
      <img
        className=""
        id="i03tsc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirmda8f.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="ix7tj8">
        <>Diseño y desarrollo web</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipfp76" className="">
      
      <div className="" id="ijkwpw">
        <>Sitios web modernos, rápidos y optimizados para convertir visitantes en clientes. Desde landing pages hasta tiendas en línea: funcionalidad y estética en perfecta armonía.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i5tz32"
        className=""
        data-aos="fade-down"
        data-aos-duration="200"
      >
      
      <div id="iukwew" className="">
      
      <div id="ifggnb" className="">
      
      <div id="iwyl5q" className="">
      
      <img
        className=""
        id="i307vz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirmtgih.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iqj6ga">
        <>Creative Content Creation</>
      </div>
      <>
        </>
      </div>
      
      <div id="i6a0ne" className="">
      
      <div className="" id="i9gi1i">
        <>From video production to compelling copy, our creative team ensures that your brand message resonates across all platforms.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="is3nwf"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="if5mmt" className="">
      
      <div id="i77y89" className="">
      
      <div id="iy13dn" className="">
      
      <img
        className=""
        id="isxae4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirmu9kj.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="i8gmp8">
        <>SEO & SEM Optimization</>
      </div>
      <>
        </>
      </div>
      
      <div id="idqlfl" className="">
      
      <div className="" id="ivrc6f">
        <>Boost your visibility with search engine strategies that put your business in front of the right people, at the right time.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="iuuuu7"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i35ga1" className="">
      
      <div id="i09y6u" className="">
      
      <div id="ixj4v2" className="">
      
      <img
        className=""
        id="iazg9m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirmur33.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="io9fbo">
        <>Social Media Management</>
      </div>
      <>
        </>
      </div>
      
      <div id="i25f5a" className="">
      
      <div className="" id="iee7mn">
        <>Engage your audience with targeted social media campaigns designed to grow your brand’s community and influence.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i07pu5" className="">
      
      <div id="iqoj8m" className="">
      <>
        </>
      </div>
      
      <div id="isacyb" className="">
      
      <img
        className=""
        id="ittav4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirmwifq.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ii5lvd" className="">
      
      <img
        className=""
        id="ida4hh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirn24j7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ilsho4" className="">
      
      <div id="i716zi" className="">
      
      <div id="i11rug" className="">
      
      <div className="" id="idg36y">
        <>Porque</>
      </div>
      <>
        </>
      </div>
      
      <div id="iq2ach" className="">
      
      <div className="" id="iuhrtr">
        
      <span className="" id="issc5q">
        <>Elegirnos</>
      </span>
      
      </div>
      
      <img
        className=""
        id="ifycmh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiz4ffq3.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ilxkgu" className="">
      
      <div className="" id="i0w528">
        <>Animagraphics Studio adopta un enfoque colaborativo e iterativo del diseño, centrándose en comprender y satisfacer las necesidades únicas de cada cliente.</>
      </div>
      <>
        </>
      </div>
      
      <div id="i6tun3" className="">
      
      <div id="imj5tl" className="">
      
      <div
        id="ird7zi"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iy824u" className="">
      
      <div id="if6iuy" className="">
      
      <div className="" id="i5lw2g">
        <>Diseño y desarrollo web</>
      </div>
      <>
        </>
      </div>
      
      <div id="inlxpo" className="">
      
      <div className="" id="i9xrig">
        <>Cada proyecto parte de una visión clara de tu marca y tus objetivos.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="igx4o2"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iv2ie2" className="">
      
      <div id="i9qwu6" className="">
      
      <div className="" id="ixrnkb">
        <>Creatividad sin límites</>
      </div>
      <>
        </>
      </div>
      
      <div id="i3zkl4" className="">
      
      <div className="" id="ixa9yi">
        <>Diseños frescos, innovadores y alineados con tu identidad.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i7q4aj"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iclw7t" className="">
      
      <div id="i1biww" className="">
      
      <div className="" id="icsaqq">
        <>Resultados medibles</>
      </div>
      <>
        </>
      </div>
      
      <div id="i3fu0w" className="">
      
      <div className="" id="izndyr">
        <>Optimizamos cada acción para maximizar tu retorno de inversión.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i5ws1l"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iie72e" className="">
      
      <div id="imoddk" className="">
      
      <div className="" id="ij9vp7">
        <>Experiencia comprobada</>
      </div>
      <>
        </>
      </div>
      
      <div id="igtlc5" className="">
      
      <div className="" id="iqnwp2">
        <>Marcas grandes y pequeñas confían en nosotros para crecer.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="ipoy4h" className="">
      
      <img
        className=""
        id="i06g8i"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirogxqz.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8f7ok" className="">
      
      <div id="ikcpmq" className="">
      <>
        </>
      </div>
      
      <div id="ieaulr" className="">
      
      <div id="i0i31g" className="">
      
      <div className="" id="iwky4t">
        <>Muestra tu</>
      </div>
      <>
        </>
      </div>
      
      <div id="ilibr4" className="">
      
      <div className="" id="ifqksd">
        
      <span className="" id="ih7bj1">
        <>mejor cara</>
      </span>
      
      </div>
      
      <img
        className=""
        id="i3vme2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiz4ffq3.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="igafzl" className="">
      
      <div className="" id="i3cv95">
        <>Explora nuestros proyectos y descubre cómo ayudamos a transformar ideas en resultados.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ios1qr" className="">
      
      <video
        id="idetdq"
        className=""
        src="https://assetsprojects.s3.amazonaws.com/405gznimm3vebrj.mp4"
        loop={true}
        autoPlay={true}
        controls={true}
        muted={true}
        playsInline={true}
      />
      
      <video
        id="it7qae"
        className=""
        src="https://assetsprojects.s3.amazonaws.com/405gznimn7qr52m.mp4"
        loop={true}
        autoPlay={true}
        controls={undefined}
        muted={true}
        playsInline={true}
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ipxk4j" className="">
      
      <div id="id6p1g" className="">
      <>
        </>
      </div>
      
      <div id="iw5q9a" className="">
      
      <div id="izysdf" className="">
      
      <div id="ib390j" className="">
      
      <div className="" id="ihh3qa">
        
      <i className="" id="">
        <>Innovate</>
      </i>
      
      </div>
      
      <img
        className=""
        id="iy75ll"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirq83q2.png"
        alt="undefined"
      />
      
      <div className="" id="i0tj2h">
        
      <i className="" id="">
        <>Inspire</>
      </i>
      
      </div>
      
      <img
        className=""
        id="i1byum"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirq83q2.png"
        alt="undefined"
      />
      
      <div className="" id="id4ali">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijmrvv">
        
      <i className="" id="">
        <>Create</>
      </i>
      
      </span>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="irdubz" className="">
      
      <div id="ivfkzh" className="">
      
      <div className="" id="ii75gq">
        <>¿Listo para dar el siguiente paso?</>
      </div>
      
      <div className="" id="i599kb">
        <>Hablemos sobre tu proyecto y construyamos algo increíble juntos.</>
      </div>
      
        <a
          target=""
          className=""
          id="i98mxs"
          href="#"
        >
          
      <div className="" id="inyd1g">
        
      <a
        target=""
        className=""
        id="ijlqrm"
        href=""
        type=""
      >
        
      </a>
      
      <a
        target=""
        className=""
        id="inn86h"
        href="https://wa.me/50488006991"
        type=""
      >
        <>Hablemos</>
      </a>
      
      </div>
      
      <div id="ix1e3i" className="">
      
      <span className="material-icons " id="iuep2f">
        
      <span className="material-icons " id="ixz0ij">
        <>play_arrow</>
      </span>
      
      </span>
      <>
        </>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i49wha" className="">
      
      <div id="i58mnn" className="">
      
      <div id="irde4j" className="">
      
      <img
        className=""
        id="iahbpl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiqjkp1s.png"
        alt="undefined"
      />
      
      <div id="i6svxg" className="">
      
      <div className="" id="irtjqk">
        
      <i className="" id="ihzzog">
        
      <span className="" id="i9ersy">
        <>Animagraphic</>
      </span>
      <> Studio</>
      </i>
      
      </div>
      
      <div className="" id="irtou5">
        <>Innovate. Inspire. Create</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iiw7ww" className="">
      
      <div id="idrcpl" className="">
      
      <div className="" id="i8xrs1">
        <>Contacto</>
      </div>
      
      <div id="ihk80j" className="">
      
      <div id="inf3gk" className="">
      
      <span className="material-icons " id="i0z4wn">
        
      <span className="material-icons iconlow " id="ihe35d">
        <>mail</>
      </span>
      
      </span>
      <>
        </>
      </div>
      
      <div className="" id="ivlm8n">
        <>animagraphics@hotmail.com</>
      </div>
      <>
        </>
      </div>
      
      <div id="i4mlkf" className="">
      
      <div id="ipmc33" className="">
      
      <span className="material-icons " id="iu3b4l">
        
      <span className="material-icons iconlow2 " id="ivemsj">
        
      <span className="material-icons iconlow " id="ipwk3g">
        <>call</>
      </span>
      
      </span>
      
      </span>
      <>
        </>
      </div>
      
      <div className="" id="igz6x5">
        <>+50488006991</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ii8qrb" className="">
      
      <div className="" id="iddr8g">
        <>Animagraphics © 2026 Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinitpage);
  